<template>
  <div class="page">
    <div class="m-bg-cover"></div>
    <div class="m-content">
      <div class="m-box">
        <div class="m-nav" v-if="isAccount==1">
          <span>登录账号</span>
          <p :style="!isEdit ? 'color:#999999' : ''">{{people.userName}}</p>
        </div>
        <div class="m-nav" v-if="isName==1">
          <span>真实姓名</span>
          <p v-if="isEdit||hasIdAccess==1" :style="!isEdit&&hasIdAccess==1 ? 'color:#999999' : ''">{{people.realName}}</p>
          <input ref="inputName" class="m-input-s" v-else="" v-model="realName" @input="realName = realName.replace(/\s+/g,'')"
                 type="text" maxlength="20">
        </div>
        <div class="m-nav" v-if="isCard==1">
          <span>证件类型</span>
          <div class="m-right" @click="!isEdit&&hasIdAccess!=1 ? areaPicker=true : ''">
            <p :style="!isEdit&&hasIdAccess==1 ? 'color:#999999' : ''">{{regionName}}</p>
            <van-icon v-if="!isEdit&&hasIdAccess!=1" class="m-ico" name="arrow"/>
          </div>
        </div>
        <div class="m-nav" v-if="isCard==1"><span>证件号码</span>
          <p v-if="isEdit||hasIdAccess==1" :style="!isEdit&&hasIdAccess==1 ? 'color:#999999' : ''">{{people.idCardNum}}</p>
          <input class="m-input-s" v-else="" v-model="people.idCardNum" @input="people.idCardNum = (people.idCardNum.replace(/\s+/g,'')).toUpperCase()" type="text" maxlength="20">
        </div>
        <div class="m-nav" v-if="examNo==1">
          <span>考籍号</span>
          <p v-if="isEdit||isExamNmb" :style="!isEdit&&isExamNmb ? 'color:#999999' : ''">{{people.examinationNumb}}</p>
          <input class="m-input-s" v-else="" v-model="people.examinationNumb" type="text" maxlength="20" placeholder="请输入">
        </div>
        <!--<div class="m-nav"><span>手机号码</span>-->
          <!--<p>{{people.phone}}</p></div>-->
        <div class="m-nav" v-if="type==1">
          <span>考生类型</span>
          <div class="m-right" @click="!isEdit&&hasUpdateInfo!=1 ? isShow=true : ''">
            <p :style="!isEdit&&hasUpdateInfo==1 ? 'color:#999999' : ''">{{userTypeName}}</p>
            <van-icon v-if="!isEdit&&hasUpdateInfo!=1" class="m-ico" name="arrow"/>
          </div>
        </div>
        <div class="m-nav" v-if="major==1">
          <span>考生专业</span>
          <div class="m-right" @click="!isEdit&&hasUpdateInfo!=1 ? show=true : ''">
            <p :style="!isEdit&&hasUpdateInfo==1 ? 'color:#999999' : ''">{{userMajorName}}</p>
            <van-icon v-if="!isEdit&&hasUpdateInfo!=1" class="m-ico" name="arrow"/>
          </div>
        </div>
        <div class="m-nav" v-if="showSubject==1">
          <span>考生学科</span>
          <div class="m-right" @click="!isEdit&&hasUpdateInfo!=1 ? subShow=true : ''">
            <p :style="!isEdit&&hasUpdateInfo==1 ? 'color:#999999' : ''">{{userSubjectName}}</p>
            <van-icon v-if="!isEdit&&hasUpdateInfo!=1" class="m-ico" name="arrow"/>
          </div>
        </div>
        <div class="m-nav" v-if="isDeptId==1">
          <span>部门/年级</span>
          <div class="m-right" @click="!isEdit&&hasUpdateInfo!=1 ? depShow=true : ''">
            <p :style="!isEdit&&hasUpdateInfo==1 ? 'color:#999999' : ''">{{deptName}}</p>
            <van-icon v-if="!isEdit&&hasUpdateInfo!=1" class="m-ico" name="arrow"/>
          </div>
        </div>
      </div>
      <p class="m-card-tit">如果注册时证件号码填写错误，请重新注册账号</p>
    </div>
    <div class="m-box-btn">
      <van-button v-if="isEdit" block class="x-btn-default m-btn" native-type="button" @click="editMore()">修改信息
      </van-button>
      <van-button v-else="" block class="x-btn-log m-btn" native-type="button" @click="isOk()">确定</van-button>
    </div>
    <!--考生类型-->
    <van-popup v-model="isShow" position="bottom">
      <van-picker show-toolbar value-key="userType" title="选择考试类型" :columns="columnType" @cancel="isShow = false"
                  @confirm="chooseType"/>
    </van-popup>
    <!--考生专业-->
    <van-popup v-model="show" position="bottom">
      <van-picker show-toolbar value-key="majorName" title="选择考生专业" :columns="columnExam" @cancel="show = false"
                  @confirm="chooseState"/>
    </van-popup>
    <!--证件类型-->
    <van-popup v-model="areaPicker" position="bottom">
      <van-picker show-toolbar value-key="test" title="选择证件类型" :columns="columns" @cancel="areaPicker = false" @confirm="chooseArea"/>
    </van-popup>
    <!--学科-->
    <van-popup v-model="subShow" position="bottom">
      <van-picker show-toolbar value-key="name" title="选择考生学科" :columns="columnSub" @cancel="subShow = false"
                  @confirm="chooseSub"/>
    </van-popup>
    <!--部门/年级-->
    <van-popup v-model="depShow" position="bottom">
      <van-picker show-toolbar value-key="deptName" title="选择部门/年级" :columns="deptList" @cancel="depShow = false"
                  @confirm="chooseDep"/>
    </van-popup>
  </div>
</template>

<script>

  export default {
    components: {},
    data () {
      return {
        people: {},
        userTypeName: '',
        userTypeId: '',
        userMajorName: '',
        userMajorId: '',
        regionName:'',
        regionId:'',
        userSubjectName:'',
        userSubjectId:'',
        deptId:'',
        deptName:'',
        isShow: false,
        show: false,
        areaPicker:false,
        subShow:false,
        depShow:false,
        columnType: [],
        columnExam: [],
        columnSub: [],
        columns: [
          {test:'居民身份证',value:'1'},
          {test:'港澳居民来往内地通行证',value:'2'},
          {test:'台湾居民来往大陆通行证',value:'3'},
          {test:'护照',value:'4'}
        ],
        deptList:[],
        type: '',
        major: '',
        showSubject:'',
        isAccount:'',
        isName:'',
        isCard:'',
        isDeptId:'',
        examNo:'',
        isEdit: true,
        realName: '',
        hasIdAccess:0,
        isExamNmb:true,
        hasUpdateInfo:'',
      }
    },
    created () {
      this.getTenant()
    },
    methods: {
      chooseType (i) {
        this.isShow = false
        this.userTypeId = i.id
        this.userTypeName = i.userType
        this.userMajorId = ''
        this.userMajorName = ''
        this.getMajor(i.id)
      },
      chooseState (i) {
        this.show = false
        this.userMajorId = i.id
        this.userMajorName = i.majorName
        this.userSubjectId = ''
        this.userSubjectName = ''
        this.getSub( i.id)
//        this.major=i.test
      },
      chooseSub(i){
        this.subShow = false
        this.userSubjectId =  i.id
        this.userSubjectName =  i.name
      },
      chooseArea(i){
        this.regionName = i.test
        this.regionId = i.value
        this.areaPicker = false
        this.people.idCardNum = ''
      },
      chooseDep(i){
        this.deptId = i.deptId
        this.deptName = i.deptName
        this.depShow = false
      },
      //是否显示考生类型和专业
      getTenant () {
        this.http.getRequest({
          url:'app/userInfo/tenantNoLogin',
          msg:{},
          success:(res)=>{
            if(!res.data.showUserInfo){
              this.major = 1
              this.type = 1
              this.showSubject = 0
              this.isAccount = 1
              this.isName = 1
              this.isCard = 1
              this.examNo = 0
              this.isDeptId = 0
            }else {
              let showUserInfo = JSON.parse(res.data.showUserInfo)
              this.major = showUserInfo.userMajor
              this.type = showUserInfo.userType
              this.showSubject = showUserInfo.userSubject
              this.isAccount = showUserInfo.userName
              this.isName = showUserInfo.name
              this.isCard = showUserInfo.isCard
              this.examNo = showUserInfo.examNo
              this.isDeptId = showUserInfo.deptId
                console.log(showUserInfo,this.major)
            }
//            this.major = res.data.showMajor
//            this.type = res.data.showType
//            this.showSubject = res.data.showSubject
            this.getInfo()
          }
        })
      },
      //获取个人信息
      getInfo () {
        this.http.postRequest({
          url: 'app/user/getUserInfo',
          msg: {},
          success: (res) => {
            this.people = res.data
            this.hasIdAccess = res.data.hasNameAccess
            this.hasUpdateInfo = res.data.hasUpdateInfo
            if (this.type == 1) {
              this.userTypeId = res.data.userTypeId
              this.getTypeStu(this.userTypeId)
            }
            if (this.major == 1) {
              this.userMajorId = res.data.userMajorId
              this.getMajor(res.data.userTypeId, this.userMajorId)
            }
            if(this.showSubject == 1){
              this.userSubjectId = res.data.userSubjectId
              this.getSub(res.data.userMajorId,this.userSubjectId)
            }
            if(this.people.region){
              this.columns.forEach((item) => {
                if(item.value==this.people.region){
                  this.regionName = item.test
                  this.regionId = item.value
                }
              })
            }
            if(this.isDeptId == 1){
              this.deptName = this.people.deptName
              this.deptId = this.people.deptId
              this.getDeptList()
            }
          }
        })
      },
      getTypeStu (i) {
        this.http.getRequest({
          url: 'app/userInfo/findTypeList',
          msg: {},
          success: (res) => {
            this.columnType = res.data
            if (i && this.columnType.length > 0) {
              this.columnType.forEach((item) => {
                if (item.id == i) {
                  this.userTypeName = item.userType
                }
              })
            }
          }
        })
      },
      getMajor (i, y) {
        this.http.getRequest({
          url: 'app/userInfo/findMajorList',
          msg: {userTypeId: i},
          success: (res) => {
            this.columnExam = res.data
            if (y && this.columnExam.length > 0) {
              this.columnExam.forEach((item) => {
                if (item.id == y) {
                  this.userMajorName = item.majorName
                }
              })
            }
          }
        })
      },
//      学科下拉
      getSub(i,y){
        this.http.getRequest({
          url: 'app/userInfo/findUserSubjectList',
          msg: {majorId:i},
          success: (res) => {
            this.columnSub = res
            if (y && this.columnSub.length > 0) {
              this.columnSub.forEach((item) => {
                if (item.id == y) {
                  this.userSubjectName = item.name
                }
              })
            }
          }
        })
      },
//      部门年级
      getDeptList(){
        this.http.getRequest({
          url:'app/userInfo/getDeptList',
          msg:{},
          success:(res)=>{
            if(res.data){
              let arr = res.data
              arr.forEach((item)=>{
                delete item.children
              })
              this.deptList = arr
            }
          }
        })
      },
      editMore () {
        this.realName = this.people.realName
        this.isEdit = false
        if(this.people.examinationNumb){
          this.isExamNmb = true
        }else {
          this.isExamNmb = false
        }
        if(this.hasIdAccess==1){
          return
        }
        this.$nextTick(()=>{
          this.$refs.inputName.focus()
        })
      },
      //提交修改信息
      isOk () {
        if (!this.realName) {
          this.utils.toastNone('请填写姓名！')
          return
        }
        if(!this.regionId){
          this.utils.toastNone('请选择证件类型！')
          return
        }
        if (this.type == 1 && (!this.userTypeId)) {
          this.utils.toastNone('请选择考生类型！')
          return
        }
        if (this.major == 1 && (!this.userMajorId)) {
          this.utils.toastNone('请选择考生专业！')
          return
        }
        if (this.showSubject == 1 && (!this.userSubjectId)) {
          this.utils.toastNone('请选择考生学科！')
          return
        }
        if(this.isDeptId==1 && (!this.deptId)){
          this.utils.toastNone('请选择部门/年级！')
          return
        }
        this.http.postRequest({
          url: 'app/user/updateTypeAndMajor',
          msg: {
            id: this.people.id,
            realName: this.realName,
            userTypeId: this.userTypeId,
            userMajorId: this.userMajorId,
            examinationNumb:this.people.examinationNumb,
            region:this.regionId,
            idCardNum:this.people.idCardNum,
            userSubjectId:this.userSubjectId,
            deptId:this.deptId
          },
          success: (res) => {
            this.isEdit = true
            this.getTenant()
            this.utils.toastSuccess(res.msg)
          }
        },true)
      }
    },
    mounted () {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  @import "~@/assets/css/variable.less";

  .page {
    background: #F4F6F9;
    .m-bg-cover {
      position: absolute;
      left: 0;
      right: 0;
      height: 180px;
      background: linear-gradient(360deg, #F4F6F9 0%, #2B6CF9 28%, #2B6CF9 100%);
      z-index: -1;
    }
    .m-content {
      padding: 30px 12px;
      .m-box {
        background: #ffffff;
        border-radius: 4px;
        padding: 0 12px;
        .m-nav {
          padding: 15px 0;
          border-bottom: 1Px solid #D4D4D4;
          display: flex;
          justify-content: space-between;
          > span {
            display: inline-block;
            width: 90px;
            font-weight: bold;
            white-space: nowrap;
          }
          > p {
            flex: 1;
            text-align: right;
            font-weight: bold;
          }
          .m-input-s {
            flex: 1;
            text-align: right;
            font-weight: bold;
          }
          .m-right {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            > p {
              flex: 1;
              text-align: right;
              font-weight: bold;
            }
            .m-ico {
              color: #767A7F;
              font-size: 16px;
            }
          }
        }
        .m-nav:last-child {
          border-bottom: none;
        }
      }
      .m-card-tit{
        font-size: 14px;
        color: #999999;
        margin-top: 40px;
      }
    }
    .m-box-btn {
      width: 100%;
      padding: 80px 30px 20px 30px;
      .m-btn {

      }
    }

  }
</style>

